// @ts-nocheck
import React, { useState } from "react";
import Loader from "../common/Loader/Loader";

const PincodeManager = ({
  pincodes,
  pincodeForm,
  editingPincodeId,
  pincodeSaving,
  onPincodeFormChange,
  onPincodeSubmit,
  onPincodeCancel,
  onPincodeAvailabilityChange,
  onPincodeDelete,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showPincodeModal, setShowPincodeModal] = useState(false);
  const normalizedSearch = String(searchTerm || "").trim();
  const filteredPincodes = normalizedSearch
    ? pincodes.filter((item) => String(item.pinCode || "").includes(normalizedSearch))
    : pincodes;

  const handleAddClick = () => {
    onPincodeCancel();
    setShowPincodeModal(true);
  };

  const handleModalClose = () => {
    onPincodeCancel();
    setShowPincodeModal(false);
  };

  const handleSubmit = async () => {
    const didSave = await onPincodeSubmit();

    if (didSave) {
      setShowPincodeModal(false);
    }
  };

  return (
    <section className="admin-card table-card">
      <div className="table-title-row">
        <h2>Pincodes</h2>
      </div>

      <div className="rate-admin-actions pincode-admin-actions">
        <input
          type="text"
          name="pinCode"
          inputMode="numeric"
          maxLength="6"
          placeholder="Search pincode"
          value={searchTerm}
          disabled={pincodeSaving}
          onChange={(event) => setSearchTerm(event.target.value.replace(/\D/g, ""))}
        />

        <button type="button" onClick={handleAddClick} disabled={pincodeSaving}>
          {pincodeSaving ? (
            <>
              <Loader size="sm" inline />
              Adding...
            </>
          ) : (
            "Add Pincode"
          )}
        </button>
      </div>

      <div className="city-grid">
        {filteredPincodes.length === 0 ? (
          <p>No Pincodes Found</p>
        ) : (
          filteredPincodes.map((pincodeItem, index) => {
            const pincodeMenuId = pincodeItem.id || pincodeItem.pinCode || `pincode-${index}`;

            return (
              <article className="city-card-admin pincode-card-admin" key={pincodeMenuId}>
                <div className="city-card-header">
                  <strong>{pincodeItem.pinCode || "Unnamed pincode"}</strong>
                  <button type="button" className="pincode-delete-btn" onClick={() => onPincodeDelete(pincodeItem)}>
                    Delete
                  </button>
                </div>

                <label className="pincode-availability-toggle pincode-card-toggle">
                  <input
                    type="checkbox"
                    checked={Boolean(pincodeItem.available)}
                    disabled={pincodeSaving}
                    onChange={(event) => onPincodeAvailabilityChange(pincodeItem, event.target.checked)}
                  />
                  Available
                </label>
              </article>
            );
          })
        )}
      </div>

      {showPincodeModal ? (
        <div className="modal-overlay">
          <section className="admin-modal" role="dialog" aria-modal="true" aria-labelledby="pincode-modal-title">
            <header className="admin-modal-header">
              <div>
                <span>Pincode</span>
                <h3 id="pincode-modal-title">Add pincode</h3>
              </div>
              <button type="button" aria-label="Close pincode form" onClick={handleModalClose} disabled={pincodeSaving}>
                ×
              </button>
            </header>

            <label className="admin-modal-field">
              <span>Pincode</span>
              <input
                type="text"
                inputMode="numeric"
                maxLength="6"
                value={pincodeForm.pinCode}
                disabled={pincodeSaving}
                onChange={(event) => onPincodeFormChange("pinCode", event.target.value.replace(/\D/g, ""))}
              />
            </label>

            <label className="pincode-availability-toggle pincode-modal-toggle">
              <input
                type="checkbox"
                checked={pincodeForm.available}
                disabled={pincodeSaving}
                onChange={(event) => onPincodeFormChange("available", event.target.checked)}
              />
              Available
            </label>

            <div className="admin-modal-actions">
              <button type="button" onClick={handleModalClose} disabled={pincodeSaving}>
                Cancel
              </button>
              <button type="button" className="save-btn" onClick={handleSubmit} disabled={pincodeSaving}>
                {pincodeSaving ? (
                  <>
                    <Loader size="sm" inline />
                    Adding...
                  </>
                ) : (
                  "Add pincode"
                )}
              </button>
            </div>
          </section>
        </div>
      ) : null}
    </section>
  );
};

export default PincodeManager;
